import React from 'react';
import { getLoyaltyStorage } from '../../util';
export var AccountRail = function AccountRail(_ref) {
  var _account$account;

  var _ref$account = _ref.account,
      account = _ref$account === void 0 ? {} : _ref$account,
      _ref$logout = _ref.logout,
      logout = _ref$logout === void 0 ? {} : _ref$logout,
      links = _ref.links,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? function (index) {
    return console.log("Clicked" + index);
  } : _ref$show,
      activeIndex = _ref.activeIndex;
  var data = ((_account$account = account.account) === null || _account$account === void 0 ? void 0 : _account$account.idToken) || {};
  var loyaltyStorage = getLoyaltyStorage();
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-account-rail"
  }, /*#__PURE__*/React.createElement(LinkList, {
    links: links,
    action: show,
    activeIndex: activeIndex
  }), /*#__PURE__*/React.createElement("a", {
    className: "cb-account-rail__option",
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      return logout();
    }
  }, "Logout"));
};

var LinkList = function LinkList(_ref2) {
  var links = _ref2.links,
      action = _ref2.action,
      activeIndex = _ref2.activeIndex;
  return links.map(function (link, index) {
    return /*#__PURE__*/React.createElement("a", {
      key: 'linklist' + index,
      className: "cb-account-rail__option ".concat(activeIndex === index ? "is-active" : ""),
      href: "/rewards/my-info".concat(link.page) // onClick={(e) => {e.preventDefault(); action(index)}}

    }, (link === null || link === void 0 ? void 0 : link.labelOverride) || link.label);
  });
};